// extracted by mini-css-extract-plugin
export default {"List":"_7gfOA9pmFZcJPHx0ZyZt5tLmOIVVBpfAAQFZBgi11kq"};